import { useJobContext } from 'pages/Job/context';

import FinanceFormContent from './Content';
import NoAPRs from './NoAPRs';
import FinanceFormProvider from './context';

const PaymentFormFinance: React.FunctionComponent = function () {
  const { allRates, job } = useJobContext();
  if (!allRates || !job) return <NoAPRs />;
  return (
    <FinanceFormProvider allRates={allRates} job={job}>
      <FinanceFormContent />
    </FinanceFormProvider>
  );
};

export default PaymentFormFinance;
